"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMegaphoneFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M8.28 19A5.32 5.32 0 015 18.13c-1.28-.88-2-2.48-2-4.63s.68-3.74 2-4.62A5.58 5.58 0 018.5 8H14v11H8.28zM7.11 21a15 15 0 003.14 7.66l.3.34h4.58l-1-8zM16.02 7.61v13.78l11.98 4V3.61l-11.98 4z" })));
}
exports.default = SvgMegaphoneFilled;
//# sourceMappingURL=MegaphoneFilled.js.map